export default __webpack_public_path__ + "static/Economic Model Update - Italian-c032f7b8a400044a4da9c10322904818.pdf";